import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken } from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login", "/user_agreement"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  const hasToken = getToken();

  if (hasToken) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({ path: "/" });
      NProgress.done();
    } else {
      // const hasGetUserInfo = store.getters.name;
      const hasGetUserInfo =
        store && store.getters && store.getters.name ? store.getters.name : "";
      console.log("store.getters.name:", store.getters.name);
      // const hasGetUserInfo = ''
      if (hasGetUserInfo) {
        next();
      } else {
        try {
          if (store.getters.menulist.length === 0) {
            // console.log("store.getters.menulist:", store.getters.menulist);
            // get user info
            // await store.dispatch("user/getInfo").then(res => {
            //   const roles = res.menulist;
            //   // console.log(roles);
            //   store
            //     .dispatch("user/getPermissionMenuList", { roles })
            //     .then(() => {
            //       /* console.log('路由权限判断完成')
            //     console.log(store.getters.menulist) */
            //       router.addRoutes(store.getters.menulist); // 动态添加可访问路由表
            //       router.options.routes = store.getters.menulist;
            //       next({ ...to, replace: true });
            //     });
            // });
            const userInfo = await store.dispatch("user/getInfo");
            const roles = userInfo.menulist;
            await store.dispatch("user/getPermissionMenuList", {
              roles
            });
            router.addRoutes(store.getters.menulist);
            router.options.routes = store.getters.menulist;
            next({ ...to, replace: true });
          } else {
            next();
          }

          /* await store.dispatch('user/getInfo') */
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch("user/resetToken");
          Message.error(error || "Has Error");
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
